// The widget's own analytics state, held at module scope rather than in React
// context on purpose: `closeWidget` lives in CalendarContext, which sits ABOVE
// SessionProvider and therefore cannot read the step the consumer reached (the
// same provider-ordering constraint CIN-6274 documents at length). One widget
// runs per page, so a module-level record is the whole story.
const INITIAL = {
  // Both of these change which steps a consumer walks, so they decide step_index.
  phoneVerificationRequired: false,
  locationStepSkipped: false,
  // Set only when a stored session id was found AND the server returned it.
  // Not "a session exists": by the time any screen renders one always does.
  isResumedSession: false,
  lastStepId: null,
  hasBooked: false,
  // One-shot: armed by the effects that move the consumer on their behalf, read
  // and cleared by the next step report so only that transition is auto_skip.
  autoAdvancePending: false,
};

let state = { ...INITIAL };

export const setStepContext = ({ phoneVerificationRequired, locationStepSkipped }) => {
  if (phoneVerificationRequired !== undefined) state.phoneVerificationRequired = !!phoneVerificationRequired;
  if (locationStepSkipped !== undefined) state.locationStepSkipped = !!locationStepSkipped;
};

export const noteSessionResumed = (resumed) => {
  state.isResumedSession = !!resumed;
};

export const noteStepReached = (stepId) => {
  state.lastStepId = stepId;
};

export const noteBooked = () => {
  state.hasBooked = true;
};

// Called immediately before a setCurrentStep the consumer did not ask for.
export const noteAutoAdvance = () => {
  state.autoAdvancePending = true;
};

export const consumeAutoAdvance = () => {
  const pending = state.autoAdvancePending;
  state.autoAdvancePending = false;
  return pending;
};

export const analyticsState = () => state;

// Tests mount the widget repeatedly in one module registry.
export const resetAnalyticsState = () => {
  state = { ...INITIAL };
};
